import "./Footer.css";

export default function Footer() {
  return <footer>{`Copyright © By Tanat29 2023`}</footer>;
}
